module.exports = __webpack_public_path__ + "img/help_dataset_celltype_small.1037eb7a.png";